import React from 'react'
import PropTypes from 'prop-types'
import ProgressBar from './progressBar'

class BenefitRow extends React.Component {

  constructor (props) {
    super (props)
    this.state = {
      benefit: {}
    }
  }

  getBenefit (benefit) {
  }

  render () {
    return (
      <div className="benefit-row">
        <ProgressBar
          benefit={this.props.benefit}
          color={this.props.color}
          showNext={this.props.showNext}
          id={this.props.id}
          benefits={this.props.benefits}
          speed={this.props.benefitStates.speed}
          pluralize={this.props.pluralize}
          benefitStates={this.props.benefitStates.benefitStates}
          paidLeaveSubstitution={this.props.paidLeaveSubstitution}
          jobProtectedLeaveSubstitution={this.props.jobProtectedLeaveSubstitution}
        />
      </div>
    )

  }
}

BenefitRow.propTypes = {
  benefit: PropTypes.object
}

export default BenefitRow;
